<template>
    <div>
        <div class="content">
            <div class="row mt-5">
                <div class="col-md-12">
                    <h3>STATISTIQUES WEEDO TRUST</h3>
                    <div class="card">
                        <div class="card-body">
                            <div class="col-md-12">
                                <div class="row">
                                    <div
                                        class="col-xl-10 col-lg-12 col-12 order-xl-1 order-1"
                                    >
                                        <div class="row">
                                            <!-- Date de début -->
                                            <base-input
                                                class="col-md-4 mb-2"
                                                label="Date de début"
                                            >
                                                <el-date-picker
                                                    v-model="selectedStartDate"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="DATE"
                                                    :picker-options="
                                                        startPickerOptions
                                                    "
                                                ></el-date-picker>
                                            </base-input>

                                            <!-- Date de fin -->
                                            <base-input
                                                class="col-md-4 mb-2"
                                                label="Date de Fin"
                                            >
                                                <el-date-picker
                                                    v-model="selectedEndDate"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="DATE"
                                                    :picker-options="
                                                        endPickerOptions
                                                    "
                                                ></el-date-picker>
                                            </base-input>
                                        </div>
                                    </div>
                                    <div
                                        class="col-xl-2 col-lg-12 col-12 order-xl-2 order-3"
                                    >
                                        <div class="row">
                                            <base-button
                                                v-if="isLoadingData"
                                                loading
                                                class="btn btn-just-icon btn-default mt-4 d-block"
                                                >{{
                                                    $t(
                                                        "buttons.BtnLoad"
                                                    ).toUpperCase()
                                                }}...</base-button
                                            >
                                            <button
                                                v-else
                                                class="btn btn-just-icon btn-default mt-4 d-block"
                                                @click="getData()"
                                            >
                                                {{
                                                    $t(
                                                        "buttons.BtnSearch"
                                                    ).toUpperCase()
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-chart p-3" style="min-height: 600px">
                        <div class="row p-3 h-100">
                            <h3
                                class="col-6 card-title text-uppercase text-left"
                                v-if="switchChart === 'INTERACTION'"
                            >
                                Statistiques Interaction
                            </h3>
                            <h3
                                class="col-6 card-title text-uppercase text-left"
                                v-if="switchChart === 'INTEGRATION'"
                            >
                                Statistiques Intérogation
                            </h3>
                            <div class="col-6 column-content text-right">
                                <base-button
                                    v-if="isLoadingData"
                                    loading
                                    :class="{
                                        active: switchChart === 'INTERACTION',
                                    }"
                                    class="btn btn-sm btn-info btn-simple"
                                    >INTERACTION...
                                </base-button>
                                <base-button
                                    v-else
                                    class="btn btn-sm btn-info btn-simple"
                                    @click="switchChartTrack"
                                    :class="{
                                        active: switchChart === 'INTERACTION',
                                    }"
                                    >INTERACTION
                                </base-button>
                                <base-button
                                    v-if="isLoadingData"
                                    loading
                                    :class="{
                                        active: switchChart === 'INTEGRATION',
                                    }"
                                    class="btn btn-sm btn-info btn-simple"
                                    >INTERROGATION...
                                </base-button>
                                <base-button
                                    v-else
                                    class="btn btn-sm btn-info btn-simple"
                                    @click="switchChartTrack"
                                    :class="{
                                        active: switchChart === 'INTEGRATION',
                                    }"
                                    >INTERROGATION
                                </base-button>
                            </div>
                        </div>
                        <div class="col-12 pb-3">
                            <div
                                class="btn-group btn-group-toggle pull-right"
                                data-toggle="buttons"
                                v-if="switchChart === 'INTEGRATION'"
                            >
                                <base-button
                                    class="btn btn-sm btn-primary btn-simple"
                                    @click="switchChartIntegration"
                                    :class="{
                                        active: switchChartInt === 'GLOBAL',
                                        'text-muted':
                                            switchChartInt == 'DETAIL',
                                    }"
                                    >Globale
                                </base-button>
                                <base-button
                                    class="btn btn-sm btn-primary btn-simple"
                                    @click="switchChartIntegration"
                                    :class="{
                                        active: switchChartInt === 'DETAIL',
                                        'text-muted':
                                            switchChartInt == 'GLOBAL',
                                    }"
                                    >Détails
                                </base-button>
                            </div>
                        </div>
                        <div class="col-12 pb-3">
                            <div
                                class="btn-group btn-group-toggle pull-right"
                                data-toggle="buttons"
                                v-if="switchChart === 'INTERACTION'"
                            >
                                <base-button
                                    class="btn btn-sm btn-primary btn-simple"
                                    @click="switchChartInteraction"
                                    :class="{
                                        active:
                                            switchChartInter === 'CONNEXION',
                                        'text-muted':
                                            switchChartInter == 'UTILISATION',
                                    }"
                                    >Connexion
                                </base-button>
                                <base-button
                                    class="btn btn-sm btn-primary btn-simple"
                                    @click="switchChartInteraction"
                                    :class="{
                                        active:
                                            switchChartInter === 'UTILISATION',
                                        'text-muted':
                                            switchChartInter == 'CONNEXION',
                                    }"
                                    >Utilisation
                                </base-button>
                            </div>
                        </div>
                        <div
                            class="row"
                            v-show="
                                switchChart === 'INTERACTION' &&
                                switchChartInter === 'CONNEXION'
                            "
                        >
                            <div class="col" v-if="barChart2.chartData">
                                <!-- <div class="card-body h-100"> -->
                                <div class="card-body">
                                    <line-chart
                                        style="height: 400px"
                                        :chart-data="barChart2.chartData"
                                        :extra-options="barChart2.extraOptions"
                                        :gradient-colors="
                                            configChart.gradientColors
                                        "
                                        :gradient-stops="
                                            configChart.gradientStops
                                        "
                                    >
                                    </line-chart>
                                </div>
                            </div>
                        </div>
                        <div
                            class="row"
                            v-show="
                                switchChart === 'INTERACTION' &&
                                switchChartInter === 'UTILISATION'
                            "
                        >
                            <div class="col">
                                <div
                                    class="card-body"
                                    v-if="barChart4.chartData"
                                >
                                    <line-chart
                                        style="height: 400px"
                                        :chart-data="barChart4.chartData"
                                        :extra-options="barChart4.extraOptions"
                                        :gradient-colors="
                                            configChart.gradientColors
                                        "
                                        :gradient-stops="
                                            configChart.gradientStops
                                        "
                                    >
                                    </line-chart>
                                </div>
                            </div>
                        </div>
                        <div
                            class="row"
                            v-show="
                                switchChart === 'INTEGRATION' &&
                                switchChartInt === 'GLOBAL'
                            "
                        >
                            <div class="col" v-if="barChart1.chartData">
                                <div class="card-body">
                                    <line-chart
                                        style="height: 400px"
                                        :chart-data="barChart1.chartData"
                                        :extra-options="barChart1.extraOptions"
                                        :gradient-colors="
                                            configChart.gradientColors
                                        "
                                        :gradient-stops="
                                            configChart.gradientStops
                                        "
                                    >
                                    </line-chart>
                                </div>
                            </div>
                        </div>
                        <div
                            class="row"
                            v-show="
                                switchChart === 'INTEGRATION' &&
                                switchChartInt === 'DETAIL'
                            "
                        >
                            <div class="col" v-if="barChart3.chartData">
                                <div class="card-body">
                                    <bar-chart
                                        style="height: 400px"
                                        :chart-data="barChart3.chartData"
                                        :extra-options="chartOptions1"
                                        :gradient-colors="
                                            configChart.gradientColors
                                        "
                                        :gradient-stops="
                                            configChart.gradientStops
                                        "
                                    >
                                    </bar-chart>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div
                                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                            >
                                <div class="col-xl-1 col-6">
                                    <base-input>
                                        <el-select
                                            class="select-primary pagination-select"
                                            v-model="pagination.perPage"
                                            placeholder="Per page"
                                        >
                                            <el-option
                                                class="select-primary"
                                                v-for="item in pagination.perPageOptions"
                                                :key="item"
                                                :label="item"
                                                :value="item"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>
                                <div class="col-xl-11 col-6">
                                    <label
                                        style="
                                            margin-top: 10px;
                                            font-size: 0.75rem;
                                        "
                                        >{{
                                            $t(
                                                "labels.Datatable.NbrLinePerPage"
                                            ).toUpperCase()
                                        }}</label
                                    >
                                </div>
                            </div>

                            <el-table
                                :data="filterStats"
                                row-class-name="stats-table-rows"
                                show-summary :summary-method="getSummaries"
                            >
                                <el-table-column
                                    prop="date"
                                    label="Date"
                                    sortable
                                >
                                    <template slot-scope="scope">
                                        {{ formatDate(scope.row.date) }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="user"
                                    label="Nom"
                                    :width="300"
                                    sortable
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.user }} (
                                        {{ scope.row.societe }})
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="nombre_connexions"
                                    label="Connexions"
                                    sortable
                                ></el-table-column>
                                <el-table-column
                                    prop="nombre_interrogations"
                                    label="INTERROGATIONs"
                                    sortable
                                ></el-table-column>
                                <el-table-column
                                    prop="nombre_premium"
                                    label="Données Premiums"
                                    sortable
                                ></el-table-column>
                                <el-table-column
                                    prop="nombre_standard"
                                    label="Données Standards"
                                    sortable
                                ></el-table-column>
                                <el-table-column
                                    prop="nombre_risque"
                                    label="Données Risques"
                                    sortable
                                ></el-table-column>
                                <el-table-column
                                    prop="taux_utilisation"
                                    label="Taux d'utilisation (%)"
                                    sortable
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.taux_utilisation }}%
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div
                            slot="footer"
                            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        >
                            <div class="">
                                <p class="card-category">
                                    {{ $t("labels.Datatable.Showing") }}
                                    {{ from + 1 }}
                                    {{ $t("labels.Datatable.to") }} {{ to }}
                                    {{ $t("labels.Datatable.of") }} {{ total }}
                                    {{ $t("labels.Datatable.entries") }}
                                </p>
                            </div>
                            <base-pagination
                                class="pagination-no-border"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="total"
                            >
                            </base-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Select, Option, DatePicker, Table, TableColumn } from "element-ui";
import { BasePagination } from "src/components";
import moment from "moment";
import BarChart from "src/components/Charts/BarChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BasePagination,
        BarChart,
        LineChart,
    },
    data() {
        return {
            switchChart: "INTERACTION",
            switchChartInt: "GLOBAL",
            switchChartInter: "CONNEXION",
            barChart2: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            barChart4: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                    tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            // Return the month as the title
                            return data.labels[tooltipItem[0].index];
                        },
                        label: function (tooltipItem, data) {
                            const datasetLabel =
                                data.datasets[tooltipItem.datasetIndex].label ||
                                "";
                            const value = tooltipItem.yLabel.toFixed(2); // Format the value with two decimal places
                            return `${datasetLabel}: ${value} %`; // Add euro symbol
                        },
                    },
                    }
                },
                /* gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0], */
            },
            barChart1: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            configChart: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,

                    hover: {
                        animationDuration: 0,
                    },
                    animation: {
                        duration: 0,
                        onComplete: function () {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;

                            ctx.font = Chart.helpers.fontString(
                                Chart.defaults.global.defaultFontSize,
                                Chart.defaults.global.defaultFontStyle,
                                Chart.defaults.global.defaultFontFamily
                            );
                            ctx.textAlign = "center";
                            ctx.textBaseline = "bottom";
                            var gradient = ctx.createLinearGradient(
                                0,
                                0,
                                chartInstance.width,
                                0
                            );
                            gradient.addColorStop("0.5", "grey");
                            ctx.fillStyle = gradient;
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta =
                                    chartInstance.controller.getDatasetMeta(i);
                                if (screen.width > 550)
                                    meta.data.forEach(function (bar, index) {
                                        var data =
                                            dataset.data[
                                                index
                                            ].toLocaleString();
                                        ctx.fillText(
                                            data,
                                            bar._model.x,
                                            bar._model.y - 3
                                        );
                                    });
                            });
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            chartOptions1: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                suggestedMin: 0,
                                suggestedMax: 1,
                                padding: 30,
                                fontColor: "#9e9e9e",
                                callback: function (value) {
                                    return value;
                                },
                            },
                        },
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                drawBorder: false,
                                color: "rgba(253,93,147,0.1)",
                                zeroLineColor: "transparent",
                            },
                            ticks: {
                                // padding: 20,
                                fontColor: "#9e9e9e",
                            },
                        },
                    ],
                },
                /* tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            // Return the month as the title
                            return data.labels[tooltipItem[0].index];
                        },
                        label: function (tooltipItem, data) {
                            const datasetLabel =
                                data.datasets[tooltipItem.datasetIndex].label ||
                                "";
                            const value = tooltipItem.yLabel.toFixed(2); // Format the value with two decimal places
                            return datasetLabel == "LTV/CAC"
                                ? `${datasetLabel}: ${value} `
                                : `${datasetLabel}: ${value} €`; // Add euro symbol
                        },
                    },
                }, */
            },
            barChart3: {
                extraOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    ...chartConfigs.barChartOptionsGradient,

                    hover: {
                        animationDuration: 0,
                    },
                    animation: {
                        duration: 0,
                        onComplete: function () {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;

                            ctx.font = Chart.helpers.fontString(
                                Chart.defaults.global.defaultFontSize,
                                Chart.defaults.global.defaultFontStyle,
                                Chart.defaults.global.defaultFontFamily
                            );
                            ctx.textAlign = "center";
                            ctx.textBaseline = "bottom";
                            var gradient = ctx.createLinearGradient(
                                0,
                                0,
                                chartInstance.width,
                                0
                            );
                            gradient.addColorStop("0.5", "grey");
                            ctx.fillStyle = gradient;
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta =
                                    chartInstance.controller.getDatasetMeta(i);
                                if (screen.width > 550)
                                    meta.data.forEach(function (bar, index) {
                                        var data =
                                            dataset.data[
                                                index
                                            ].toLocaleString();
                                        ctx.fillText(
                                            data,
                                            bar._model.x,
                                            bar._model.y - 3
                                        );
                                    });
                            });
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                            position: "top",
                            align: "start",
                            labels: {
                                boxWidth: 40,
                                usePointStyle: false,
                                pointStyle: "line",
                                padding: 20,
                                color: "#9e9e9e",
                                generateLabels: function (chart) {
                                    const datasets = chart.data.datasets;
                                    return datasets.map((dataset) => ({
                                        text: dataset.label,
                                        fillStyle: "transparent",
                                        strokeStyle: dataset.borderColor,
                                        lineWidth: 2,
                                        hidden: false,
                                        lineDash: dataset.borderDash || [],
                                    }));
                                },
                            },
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            isLoadingData: false,
            selectedStartDate: null,
            selectedEndDate: null,
            startDate: null, //moment().startOf('month').format('YYYY-MM-DD'),
            endDate: null, //moment().format('YYYY-MM-DD'),
            daily_stats: [],
            accessToken: localStorage.getItem("token_jwt"),
            selectedDate: "",
            statsData: [
                {
                    date: "2025-01-29",
                    connections: 15,
                    queries: 120,
                    quota: 200,
                    premiumData: 80,
                    riskData: 30,
                    standardData: 10,
                    creditUsage: 40,
                },
                {
                    date: "2025-01-30",
                    connections: 22,
                    queries: 140,
                    quota: 200,
                    premiumData: 90,
                    riskData: 40,
                    standardData: 10,
                    creditUsage: 45,
                },
                {
                    date: "2025-01-31",
                    connections: 30,
                    queries: 160,
                    quota: 200,
                    premiumData: 100,
                    riskData: 50,
                    standardData: 10,
                    creditUsage: 50,
                },
                {
                    date: "2025-02-01",
                    connections: 25,
                    queries: 180,
                    quota: 200,
                    premiumData: 120,
                    riskData: 30,
                    standardData: 30,
                    creditUsage: 55,
                },
                {
                    date: "2025-02-02",
                    connections: 27,
                    queries: 200,
                    quota: 200,
                    premiumData: 140,
                    riskData: 40,
                    standardData: 20,
                    creditUsage: 60,
                },
            ],
            pagination: {
                perPage: 50,
                currentPage: 1,
                perPageOptions: [50, 100, 200],
                total: 0,
            },
        };
    },
    computed: {
        startPickerOptions() {
            return {
                disabledDate: (date) => {
                    if (this.selectedEndDate) {
                        let maxStartDate = new Date(this.selectedEndDate);
                        maxStartDate.setDate(maxStartDate.getDate() - 30); // 30 jours avant endDate
                        return (
                            date > new Date(this.selectedEndDate) ||
                            date < maxStartDate
                        );
                    }
                    return false;
                },
            };
        },
        endPickerOptions() {
            return {
                disabledDate: (date) => {
                    if (this.selectedStartDate) {
                        let minEndDate = new Date(this.selectedStartDate);
                        let maxEndDate = new Date(this.selectedStartDate);
                        maxEndDate.setDate(maxEndDate.getDate() + 30); // 30 jours après startDate
                        return (
                            date < new Date(this.selectedStartDate) ||
                            date > maxEndDate
                        );
                    }
                    return false;
                },
            };
        },
        filterStats() {
            let result = this.daily_stats;
            /* if (this.selectedDate) {
                result = result.filter(
                    (item) => item.date === this.selectedDate
                );
            } */
            // this.total = result.length;
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.daily_stats.length;
        },
        switchChartTest() {
            return (
                this.switchChart == "INTERACTION" &&
                this.switchChartInter == "CONNEXION"
            );
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            // Calcul des totaux à partir des données de la table
            const totals = data.reduce((acc, row) => ({
                connexions: acc.connexions + (Number(row.nombre_connexions) || 0),
                interrogations: acc.interrogations + (Number(row.nombre_interrogations) || 0),
                premium: acc.premium + (Number(row.nombre_premium) || 0),
                standard: acc.standard + (Number(row.nombre_standard) || 0),
                risque: acc.risque + (Number(row.nombre_risque) || 0)
            }), {
                connexions: 0,
                interrogations: 0,
                premium: 0,
                standard: 0,
                risque: 0
            });

            // Calcul de la moyenne du taux d'utilisation
            const taux_moyen = data.length ?
                (data.reduce((sum, row) => sum + (row.taux_utilisation || 0), 0) / data.length).toFixed(2)
                : 0;

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '';  // Colonne Date
                    return;
                }
                else if (index === 1) {
                    sums[index] = '';  // Colonne Nom
                    return;
                }
                else if (index === 2) {
                    sums[index] = totals.connexions;  // Connexions
                    return;
                }
                else if (index === 3) {
                    sums[index] = totals.interrogations;  // INTERROGATIONs
                    return;
                }
                else if (index === 4) {
                    sums[index] = totals.premium;  // Données Premiums
                    return;
                }
                else if (index === 5) {
                    sums[index] = totals.standard;  // Données Standards
                    return;
                }
                else if (index === 6) {
                    sums[index] = totals.risque;  // Données Risques
                    return;
                }
                else if (index === 7) {
                    sums[index] = taux_moyen + '%';  // Taux d'utilisation
                    return;
                }
                else {
                    sums[index] = '';
                    return;
                }
            });

            return sums;
        },
        createChartData(labels, data, label, options = {}) {
            return {
                labels,
                datasets: [
                    {
                        type: "line",
                        label,
                        fill: true,
                        fillColor: "blue",
                        borderColor: config.colors.myAfill,
                        borderWidth: 2,
                        borderDash: [],
                        data,
                    },
                ],
            };
        },
        createMultipleChart(labels, datasets) {
            return {
                labels,
                datasets: datasets.map((dataset) => ({
                    type: "line",
                    label: dataset.label,
                    fill: false,
                    //borderColor: config.colors.myAfill,
                    borderColor: dataset.borderColor,
                    borderWidth: 2,
                    borderDash: [],
                    data: dataset.data,
                })),
            };
        },
        updateScales(
            connexions,
            utilisations,
            integrations,
            premiumData,
            standardData,
            risqueData
        ) {
            this.barChart1.extraOptions.scales.yAxes[0].ticks.suggestedMax =
                Math.max(...integrations) + 1;
            this.barChart2.extraOptions.scales.yAxes[0].ticks.suggestedMax =
                Math.max(...connexions) + 1;
            this.barChart4.extraOptions.scales.yAxes[0].ticks.suggestedMax =
                Math.max(...utilisations) + 1;
            this.chartOptions1.scales.yAxes[0].ticks.suggestedMax =
                Math.max(...premiumData, ...standardData, ...risqueData) + 1;
        },
        forceUpdate() {
            this.$forceUpdate();
        },
        switchChartTrack() {
            this.switchChart =
                this.switchChart === "INTERACTION"
                    ? "INTEGRATION"
                    : "INTERACTION";
        },
        switchChartIntegration() {
            this.switchChartInt =
                this.switchChartInt === "GLOBAL" ? "DETAIL" : "GLOBAL";
        },
        switchChartInteraction() {
            this.switchChartInter =
                this.switchChartInter === "CONNEXION"
                    ? "UTILISATION"
                    : "CONNEXION";
        },
        getDateInFrench(dateToConvert) {
            moment.locale("fr");
            let date = moment(dateToConvert);
            return date.format("dddd D MMMM YYYY").toUpperCase();
        },
        formatDate(dateString) {
            let date = new Date(dateString);
            let day = String(date.getDate()).padStart(2, "0"); // Ajoute un zéro si besoin
            let month = String(date.getMonth() + 1).padStart(2, "0"); // Mois commence à 0
            let year = date.getFullYear();
            return `${day}-${month}-${year}`;
        },
        getData() {
            this.daily_stats = [];
            this.isLoadingData = true;
            this.axios
                .get(
                    "https://api-auth-plf.wee-do-it.net/api/v1/trust/ad_stats",
                    {
                        params: {
                            start_date: this.selectedStartDate, // format YYYY-MM-DD
                            end_date: this.selectedEndDate, // format YYYY-MM-DD
                        },
                        headers: {
                            authorization: `Bearer ${this.accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    if (response.data.success) {
                        this.daily_stats = response.data.data.daily_stats;
                        const chart_data_api =
                            response.data.data.chart_data || [];

                        let dates = [];
                        let connexions = [];
                        let utilisations = [];
                        let integrations = [];
                        let premiumData = [];
                        let standardData = [];
                        let risqueData = [];

                        if (this.selectedStartDate == null && this.selectedEndDate == null) {
                            const firstDayOfMonth = moment().startOf("month");
                            const today = moment();

                            // Générer toutes les dates du mois jusqu'à aujourd'hui
                            for (let date = moment(firstDayOfMonth); date <= today; date.add(1, "days")) {
                                dates.push(date.format("YYYY-MM-DD"));
                            }
                        } else {
                            const startDate = moment(this.selectedStartDate);
                            const endDate = moment(this.selectedEndDate);

                            for (let date = moment(startDate); date <= endDate; date.add(1, "days")) {
                                dates.push(date.format("YYYY-MM-DD"));
                            }
                        }

                        // Créer un mapping des données existantes
                        // Créer un nouveau chart_data complet avec des zéros pour les dates manquantes
                        const chart_data = dates.map((date) => {
                            const existingData = chart_data_api.find(
                                (item) => item.date == date
                            );

                            if (existingData) {
                                return existingData;
                            }

                            return {
                                date: date,
                                connexions: 0,
                                taux_utilisation: 0,
                                interrogations: 0,
                                premium: 0,
                                standard: 0,
                                risque: 0,
                            };
                        });

                        dates = chart_data.map((obj) =>
                            this.getDateInFrench(obj.date)
                        );
                        connexions = chart_data.map(
                            (obj) => obj.connexions
                        );
                        utilisations = chart_data.map(
                            (obj) => obj.taux_utilisation
                        );
                        integrations = chart_data.map(
                            (obj) => obj.interrogations
                        );
                        premiumData = chart_data.map((obj) => obj.premium);
                        standardData = chart_data.map(
                            (obj) => obj.standard
                        );
                        risqueData = chart_data.map((obj) => obj.risque);

                        //this.barChart1.chartData = chartDataIntegration;
                        this.barChart1.chartData = this.createChartData(
                            dates,
                            integrations,
                            "Nombre d'interrogations"
                        );

                        this.barChart2.chartData = this.createChartData(
                            dates,
                            connexions,
                            "Nombre de connexions"
                        );

                        this.barChart3.chartData = this.createMultipleChart(
                            dates,
                            [
                                {
                                    label: "Données Premiums",
                                    data: premiumData,
                                    borderColor: "#02c74f",
                                },
                                {
                                    label: "Données Standards",
                                    data: standardData,
                                    borderColor: "#ede403",
                                },
                                {
                                    label: "Données Risques",
                                    data: risqueData,
                                    borderColor: "#e50123",
                                },
                            ]
                        );

                        this.barChart4.chartData = this.createChartData(
                            dates,
                            utilisations,
                            "Taux d'utilisation"
                        );

                        this.updateScales(
                            connexions,
                            utilisations,
                            integrations,
                            premiumData,
                            standardData,
                            risqueData
                        );
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoadingData = false;
                });
        },
        formatPercentage() {},
        reset() {
            this.selectedDate = "";
        },
    },
};
</script>

<style>
.stats-table-rows {
    text-transform: uppercase;
}

.chart-container {
    height: 400px; /* ou la hauteur souhaitée */
    position: relative;
}
.hidden {
    display: NONE;
}
</style>
